module.exports = __webpack_public_path__ + "static/img/case-dy-page-bg-05.11c8411.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/dy/case-dy-page-bg-05.jpg
// module id = GVNL
// module chunks = 1